import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LoadContextMenuComponent } from './components/load-context-menu/load-context-menu.component';
import { WorkingTableComponent } from './working-table.component';
import { hintComponent } from './components/hint/hint.component';

@NgModule({
  declarations: [WorkingTableComponent, LoadContextMenuComponent, hintComponent],
  imports: [CommonModule, SharedModule],
  exports: [WorkingTableComponent],
})
export class WorkingTableModule {}
